// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"7fa898f8","599":"d78d1cb4"}[chunkId] + ".chunk.js";
};